<template>
    <validation-provider v-slot="v" :name="name" :rules="rules" slim mode="eager">
        <div class="form-group mb-0"
             :class="{
                 'has-feedback has-error': v.errors.length,
                 'row': isLabelSlot && inline,
                 'd-flex': inline && isLabelSlot,
             }">
            <label v-if="isLabelSlot" :for="id" :class="labelClass" class="mb-0 mt-2">
                <slot name="label"/>
            </label>
            <div :class="{'col-md-7':labelClass.length}">
                <multiselect :id="id"
                             :ref="id"
                             v-model="val"
                             :class="{ 'is-invalid': v.errors.length }"
                             :placeholder="placeholder"
                             :options="options"
                             :label="label"
                             :custom-label="customLabel"
                             :options-limit="optionsLimit"
                             :open-direction="openDirection"
                             :multiple="multiple"
                             :close-on-select="closeOnSelect"
                             :track-by="trackBy"
                             :searchable="isSearchable"
                             :disabled="disabled"
                             :select-label="$t('Choose')"
                             :selected-label="$t('Selected')"
                             :deselect-label="$t('Remove')"
                             :block-keys="['Delete']"
                             :show-labels="showLabels"
                             :allow-empty="!notEmpty"
                             :preselect-first="preselectFirst"
                             @select="onSelect"
                             @search-change="onChange"
                             @remove="onRemove">
                    <span slot="noResult">{{ $t('Nothing found') }}</span>
                    <div slot="afterList">
                        <p v-if="canAddNew" class="m-0 add-new pointer" @click="$emit('addnew')">
                            {{ $t('Create') }}
                        </p>
                    </div>
                    <span slot="noOptions">{{ $t('Nothing found') }}</span>
                </multiselect>
                <div class="invalid-feedback">
                    {{ v.errors[0] }}
                </div>
            </div>
        </div>
    </validation-provider>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'AppSelect',
    components: {
        Multiselect
    },
    props: {
        id: [String, Number],
        value: [Object, String, Number, Array],
        name: String,
        rules: String,
        options: [Array, Object],
        notEmpty: Boolean,
        noCustomBg: Boolean,
        label: String,
        searchable: Boolean,
        customLabel: Function,
        placeholder: {
            type: String,
            default: ''
        },
        openDirection: {
            type: String,
            default: 'auto'
        },
        optionsLimit: Number,
        optionType: String,
        closeOnSelect: Boolean,
        canAddNew: Boolean,
        multiple: Boolean,
        trackBy: String,
        inline: Boolean,
        disabled: Boolean,
        validation: Object,
        preselectFirst: Boolean,
        showLabels: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        val: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        labelClass() {
            if (this.inline) {
                return 'col-md-3 col-form-label text-md-right';
            }

            return '';
        },
        isLabelSlot() {
            return !!this.$slots.label;
        },
        isSearchable() {
            return this.searchable;
        }
    },
    methods: {
        onSelect(value) {
            this.$emit('select', value);
        },
        onChange(value) {
            this.$emit('search-change', value);
        },
        onRemove(value) {
            this.$emit('remove', value);
        },
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect__option--highlight, .multiselect__option--highlight::after {
    background: #17A2B8;
}

.multiselect {
    &.is-invalid {
        .multiselect__tags {
            border-color: #f16891 !important;
        }
    }
}

.multiselect__select:before {
    z-index: 1;
}

.max-w-20px {
    max-width: 20px;
}

.multiselect {
    min-height: 37px;
}

.multiselect__tag {
    margin-bottom: 0px;
    background: #17A2B8;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #17A2B8;
}

.multiselect__single {
    background: #f7fdfe !important;
}

.multiselect__tags {
    min-height: 40px;
    padding: 0.5rem !important;
    border: 1px solid #ced4da !important;
    border-radius: 2px;
    background: #f7fdfe;
}

.multiselect__select {
    height: 35px;
}

.multiselect__placeholder {
    margin-bottom: 0px;
    padding-top: 0px;
    line-height: 23px;
    color: #6c757d;
}

.multiselect__content-wrapper {
    border-color: #ced4da;
    font-size: 14px;
    line-height: 23px;
}

.multiselect__input,
.multiselect__single {
    font-size: 14px;
    padding-left: 5px;
    line-height: 23px;
    margin-bottom: 0;
}

.multiselect--above .multiselect__content-wrapper {
    border-top: 1px solid #ced4da;
}

.multiselect__option {
    min-height: 37px;
    padding: 6px 12px;
    line-height: 23px;
}

.multiselect__content p.add-new {
    background: #41b883;
    padding: 6px 12px;
    color: #fff;
}

.multiselect__option:after {
    min-height: 37px;
    padding: 6px 12px;
    line-height: 23px;
}

.multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select {
    background: none;
    color: #a6a6a6;
}
</style>
